import { cnTwMerge } from "@vega-core/utils/cnTwMerge";

type ChartNoDataProps = {
  message: string;
  dataTestId: string;
  className?: string;
};

export const ChartNoData = ({
  message,
  dataTestId,
  className,
}: ChartNoDataProps) => (
  <div
    className={cnTwMerge("flex items-center justify-center", className)}
    data-testid={dataTestId}
  >
    <p className="body-base-regular text-text/secondary">{message}</p>
  </div>
);
